export default {"src":"/_next/static/media/red-bull.c37584fa.svg","height":108,"width":320,"blurWidth":0,"blurHeight":0};